import React from 'react';

export const NotFoundSVG = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
		viewBox="0 0 200.55 269.99"
		height="100%"
		width="100%"
		preserveAspectRatio="xMidYMid meet"
		data-testid="not-found-svg"
	>
		<defs>
			<linearGradient
				id="linear-gradient"
				x1="1316.98"
				y1="230.66"
				x2="1396.36"
				y2="230.66"
				gradientTransform="matrix(-1, 0, 0, 1, 1517.54, 0)"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0" stopColor="#344563" />
				<stop offset="1" stopColor="#6c798f" />
			</linearGradient>
			<linearGradient
				id="linear-gradient-2"
				x1="170.3"
				y1="897.49"
				x2="365.15"
				y2="897.49"
				gradientTransform="translate(-125.06 -762.9) rotate(4.81)"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0" stopColor="#fff" />
				<stop offset="0.69" stopColor="#fff" stopOpacity="0.1" />
			</linearGradient>
		</defs>
		<title>Search error</title>
		<g id="Layer_2" data-name="Layer 2">
			<g id="Objects">
				<path
					fill="#cfd4db"
					d="M126.84,210.1l-9.51-9.39,13-13.23,9.52,9.39a18,18,0,0,0,8.82,4.78h0a18.06,18.06,0,0,1,8.82,4.79l38.59,38.09a14.87,14.87,0,0,1,.13,21h0a14.87,14.87,0,0,1-21,.14l-38.59-38.09a18,18,0,0,1-4.9-8.75h0A18,18,0,0,0,126.84,210.1Z"
				/>
				<path
					id="_Path_"
					data-name="&lt;Path&gt;"
					fill="url(#linear-gradient)"
					d="M126.84,210.1l-2.9-2.86a9.31,9.31,0,0,1-.09-13.15h0A9.3,9.3,0,0,1,137,194l2.9,2.86a18,18,0,0,0,8.82,4.78h0a18.06,18.06,0,0,1,8.82,4.79l38.59,38.09a14.87,14.87,0,0,1,.13,21h0a14.87,14.87,0,0,1-21,.14l-38.59-38.09a18,18,0,0,1-4.9-8.75h0A18,18,0,0,0,126.84,210.1Z"
				/>
				<path
					fill="#091e42"
					opacity={0.1}
					d="M131.63,218.46a18,18,0,0,0-4.79-8.36l-2.9-2.86a9.31,9.31,0,0,1-.09-13.15h0A9.3,9.3,0,0,1,137,194l2.9,2.86a18,18,0,0,0,8.41,4.68,79.1,79.1,0,0,1-7.72,9.12A77.4,77.4,0,0,1,131.63,218.46Z"
				/>
				<path
					fill="#344563"
					d="M155.47,145.8A77.74,77.74,0,0,0,22.41,91.7,77.24,77.24,0,0,0,0,146.82H0a77.22,77.22,0,0,0,23.13,54.81h0A77.74,77.74,0,0,0,155.47,145.8Z"
				/>
				<path
					id="_Clipping_Path_"
					data-name="&lt;Clipping Path&gt;"
					fill="#deebff"
					d="M35.62,104.74a59.17,59.17,0,1,1-17.06,42A58.81,58.81,0,0,1,35.62,104.74Z"
				/>
				<path
					id="_Path_2"
					data-name="&lt;Path&gt;"
					fill="#b2d4ff"
					d="M39.54,101.12A59.19,59.19,0,1,0,82.69,87.36,58.82,58.82,0,0,0,39.54,101.12Z"
				/>
				<path
					fill="#cce0ff"
					d="M78.09,94.6a59.17,59.17,0,0,0-52.5,23.71,59.2,59.2,0,0,0,99.68,63.28,59.2,59.2,0,0,0-47.18-87Z"
				/>
				<path
					fill="url(#linear-gradient-2)"
					d="M72.77,205.3A59.25,59.25,0,0,0,133.92,165a59.2,59.2,0,0,1-6.42.62c-19.4.74-33.31-8.64-40-13.32-20.19-14-20.75-28.19-33.7-41.34A56,56,0,0,0,40,100.76l-.44.36A59.18,59.18,0,0,0,72.77,205.3Z"
				/>
				<polygon
					id="_Path_3"
					data-name="&lt;Path&gt;"
					fill="#5e6c84"
					points="105.15 132.36 94.03 121.33 78.7 136.79 63.24 121.45 52.22 132.57 67.68 147.9 52.34 163.35 63.45 174.38 78.79 158.92 94.24 174.26 105.27 163.15 89.81 147.81 105.15 132.36"
				/>
				<path
					fill="#ffc400"
					d="M82.29,29.4,72.12.45A.68.68,0,0,0,70.81.6L67.53,28.65l-6.48-.75a.67.67,0,0,0-.72.89l10.17,29a.68.68,0,0,0,1.31-.15l3.28-28.05,6.48.76A.68.68,0,0,0,82.29,29.4Z"
				/>
				<path
					fill="#ffc400"
					d="M50.28,47.8,37.64,39.17a.29.29,0,0,0-.42.39l7,12.21-2.84,1.62a.29.29,0,0,0,0,.5L54,62.52a.3.3,0,0,0,.43-.39l-7-12.21,2.84-1.62A.29.29,0,0,0,50.28,47.8Z"
				/>
				<path
					fill="none"
					strokeLinecap="round"
					strokeMiterlimit={10}
					strokeWidth="2px"
					stroke="#344563"
					d="M104.31,36.05c-.7,2.07-9.75-1-10.44,1.11s8.35,5.11,7.66,7.18-9.75-1-10.44,1.12,8.35,5.11,7.66,7.18-9.75-1-10.44,1.12S96.66,58.87,96,61"
				/>
				<path
					fill="none"
					strokeLinecap="round"
					strokeMiterlimit={10}
					strokeWidth="2px"
					stroke="#5e6c84"
					d="M125.53,59.72c-1.59,1.49-7.85-5.2-9.45-3.71s4.66,8.19,3.06,9.69-7.86-5.21-9.46-3.72c-.74.7.21,2.51,1.28,4.4"
				/>
				<path
					fill="none"
					strokeLinecap="round"
					strokeMiterlimit={10}
					strokeWidth="2px"
					stroke="#5e6c84"
					d="M20.83,59.86c2.17.27,1.06,9.37,3.23,9.63s3.28-8.83,5.46-8.57,1.05,9.37,3.22,9.63c1,.13,1.79-1.76,2.56-3.8"
				/>
			</g>
		</g>
	</svg>
);
